import { render, staticRenderFns } from "./BotUi.vue?vue&type=template&id=1abeb712"
import script from "./BotUi.vue?vue&type=script&lang=js"
export * from "./BotUi.vue?vue&type=script&lang=js"
import style0 from "./BotUi.vue?vue&type=style&index=0&id=1abeb712&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports